import { ReactNode } from "react";
import {
  Modal,
  Button,
  ModalProps,
  ModalHeaderProps,
  ModalBodyProps,
  ModalFooterProps,
} from "rsuite";

interface IConfig {
  visibility?: boolean;
  element?: ReactNode;
}

export interface IModalGenericProps extends ModalProps {
  header: IConfig & {
    title?: string;
  } & ModalHeaderProps;
  body?: ModalBodyProps;
  footer: IConfig & {
    onSubmit?: () => void;
    isLoading?: boolean;
    submitBtnText?: string;
    cancelBtnText?: string;
  } & ModalFooterProps;
}

export function ModalGeneric({
  header,
  footer,
  children,
  open,
  onClose,
  ...rest
}: IModalGenericProps) {
  return (
    <Modal open={open} onClose={onClose} {...rest}>
      {header.visibility !== false && (
        <Modal.Header>
          {header.element ? (
            header.element
          ) : (
            <Modal.Title>{header.title}</Modal.Title>
          )}
        </Modal.Header>
      )}

      <Modal.Body style={{ maxHeight: "80vh" }}>{children}</Modal.Body>

      {footer.visibility !== false && (
        <Modal.Footer>
          {footer.element ? (
            footer.element
          ) : (
            <>
              <Button
                onClick={footer.onSubmit || onClose}
                appearance="primary"
                disabled={footer.isLoading}
              >
                {footer.submitBtnText || "Okay"}
              </Button>
              <Button onClick={onClose} appearance="subtle">
                {footer.cancelBtnText || "Cancel"}
              </Button>
            </>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
}
